import React from "react";
import { HStack, Typography, VStack } from "../primitives";
import {INCOMING_PROFILE_ATTRIBUTES} from "../../constants/bcrReview.constants";
import BcrReviewFieldRow from "./BcrReviewFieldRow";

const BcrReviewNoMatchSection = ({ t, pendingBcr, incomingFiLabel, notAvailableLabel }) => (
  <VStack spacing={2} className="bcr-review__section">
    <Typography variant="body1" className="bcr-review__banner">
      {t(
        "erps.billermanagement.bcrreview.nomatch.banner",
        "No centralized biller ID found. Approving registers this biller as a new centralized biller id."
      )}
    </Typography>
    <HStack className="bcr-review__no-match-card" spacing={0} alignItems="stretch">
      <VStack spacing={1} className="bcr-review__no-match-panel">
        <Typography variant="h3" className="bcr-review__no-match-heading">
            <strong>{`${incomingFiLabel} ${t("erps.billermanagement.bcrreview.billerid", "biller Id")} : ${pendingBcr.incomingBillerId}`}</strong>
        </Typography>
          <VStack className="bcr-review__field-list">
              {INCOMING_PROFILE_ATTRIBUTES.map((attr) => (
                  <BcrReviewFieldRow
                      key={attr.field}
                      label={t(attr.labelKey)}
                      value={pendingBcr.incomingBillerProfileDto ? pendingBcr.incomingBillerProfileDto[attr.field] : undefined}
                      notAvailableLabel={notAvailableLabel}
                  />
              ))}
          </VStack>
      </VStack>
      <VStack spacing={1} className="bcr-review__no-match-panel bcr-review__no-match-panel--divider">
        <Typography variant="h3" className="bcr-review__no-match-heading">
            <strong>{t("erps.billermanagement.bcrreview.nomatch.centralizedheading", "Centralized biller DB")}</strong>
        </Typography>
        <Typography variant="body1" className="bcr-review__empty-copy">
          {t("erps.billermanagement.bcrreview.nomatch.nodata", "No matching centralized biller found.")}
        </Typography>
      </VStack>
    </HStack>
  </VStack>
);

export default BcrReviewNoMatchSection;
